export default {
  TableHead: [
    [
      {
        displayName: 'recal.datatable.number',
      },
      {
        displayName: 'recal.datatable.ticketid',
      },
      {
        displayName: 'recal.datatable.requestresponse',
      },
      {
        displayName: 'recal.datatable.retry',
      },
    ],
  ],
};
